import { HttpClient } from '@wix/http-client'

const baseURL = window.location.origin + window.__BASEURL__
export const httpClient = new HttpClient({ baseURL })

export const ambassadorHttpClient = new HttpClient()

export const isHttpError = HttpClient.isHttpError

export * from '@wix/http-client'
